import React from 'react';
import { motion } from 'framer-motion';
import ShareBlogButton from '../../../components/ShareBlogButton/ShareBlogButton';
import './rfid-based-bus-number-announce-system-for-blind.css';
import rfidBlindImg from '../../../assets/images/RFID Image.png';

const RFIDBasedBusNumberAnnounceSystemForBlind = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        RFID Based <span>Bus Number Announce</span> System for Blind
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      ><br />
        Published On: 10th December 2024<br />
    🕒 Last Updated On: 10th December 2024
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={rfidBlindImg} alt="RFID Based System for Blind" className="project-image" />
          <h2 className="project-subtitle">RFID Based Bus Number Announce System for Blind</h2>
          <span className="project-category">Embedded Systems</span>
          <p className="project-author">Author: Praveen Kumar B</p>
          <p className="project-author">🕒3 Mins Read</p>
          <div className="blog-action-buttons">
            <a href="https://under-construction-work.netlify.app/" className="visit-project-button">→ Visit the Project</a>
            <ShareBlogButton
              blog={{
                id: "rfid-based-bus-number-announce-system-for-blind",
                title: "RFID Based Bus Number Announce System for Blind",
                path: "/blogs/blogdetail/rfid-based-bus-number-announce-system-for-blind",
                category: "Embedded Systems"
              }}
            />
          </div>
        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">A Step Towards Inclusive Public Transport 🚍</h3>
          <p className="overview-text">
            Imagine standing at a crowded bus stop. You hear the noise, see the approaching buses, and read the bus numbers to find your ride. But what if you couldn’t see at all? For visually impaired individuals, this everyday task can become a real challenge. That’s where our project steps in.
          </p>

          <h3 className="section-title">What Is This Project All About?</h3>
          <p className="overview-description">
            The <strong>RFID Based Bus Number Announce System for the Blind</strong> is designed to bridge this gap. Using RFID technology, the system announces the bus number as it arrives, making public transportation more accessible and stress-free for the visually impaired community.
          </p>

          <h3 className="section-title">How It Works ⚙️</h3>
          <p>
            Each bus is equipped with an RFID tag containing a unique identifier. At the bus stop, an RFID reader is installed, constantly scanning for nearby tags. When a bus approaches, the reader detects its tag and triggers an audio device to announce the bus number aloud.
          </p>
          <p>
            It’s a simple idea — but one that can make a massive impact.
          </p>

          <h3 className="section-title">Why This Matters 💡</h3>
          <ul className="benefits-list">
            <li><strong>Accessibility:</strong> Helps blind passengers identify the correct bus without relying on others.</li>
            <li><strong>Safety:</strong> Reduces the risk of boarding the wrong bus or being left behind.</li>
            <li><strong>Independence:</strong> Encourages self-reliant travel, empowering individuals with visual impairments.</li>
          </ul>

          <h3 className="section-title">Technical Breakdown 🛠️</h3>
          <ul className="how-it-works-list">
            <li><strong>Hardware:</strong> RFID tags, RFID readers, microcontrollers (like Arduino), and audio output systems.</li>
            <li><strong>Software:</strong> Embedded C/C++ code to read tag data and trigger announcements. Firmware links all components seamlessly.</li>
            <li><strong>Power:</strong> A stable power supply with battery backup for reliability, even during outages.</li>
          </ul>

          <h3 className="section-title">Where Can It Be Used? 🌍</h3>
          <ul className="how-it-works-list">
            <li>Public Bus Stops in cities and towns</li>
            <li>School or college transportation systems</li>
            <li>Corporate shuttles for employees</li>
            <li>Even rural stops with limited infrastructure</li>
          </ul>

          <h3 className="section-title">The Journey Ahead 🚀</h3>
          <ul className="how-it-works-list">
            <li>🔊 Add support for regional languages in announcements</li>
            <li>📱 Develop a companion mobile app for real-time alerts</li>
            <li>📍Integrate GPS for precise tracking and advanced notifications</li>
          </ul>

          <h3 className="section-title">Final Thoughts 🎯</h3>
          <p>
            Technology, when used right, can be a great equalizer. The RFID Based Bus Number Announce System is a small yet meaningful innovation that can bring massive change for many. With scalability, affordability, and inclusivity at its core, this project is just the beginning of a more accessible future in transportation.
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default RFIDBasedBusNumberAnnounceSystemForBlind;
